// src/components/Host/createHost.js
export async function createHost(hostName, hostType, hostIP, osTemplateId, groupid, prefix) {
    const url = process.env.REACT_APP_API_URL;
    const auth = process.env.REACT_APP_API_TOKEN;

    const prefixedHostName = `IMS Free Tier | ${prefix} - ${hostName}`;
    const hostValue = `${prefix} - ${hostName}`;

    const hostPayload = {
        "jsonrpc": "2.0",
        "method": "host.create",
        "params": {
            "host": hostValue,
            "name": prefixedHostName,
            "interfaces": [
                {
                    "type": hostType,
                    "main": 1,
                    "useip": 1,
                    "ip": hostIP,
                    "dns": "",
                    "port": "10050"
                }
            ],
            "groups": [
                {
                    "groupid": groupid
                }
            ],
            "templates": [
                {
                    "templateid": osTemplateId
                }
            ],
            "proxy_hostid": "14191",
            "inventory_mode": 0
        },
        "auth": auth,
        "id": 4
    };

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(hostPayload)
    });

    const data = await response.json();
    if (data.error) {
        console.error('Error creating host:', data.error);
        throw new Error('Erro ao criar host: ' + data.error.data);
    }
    console.log('Host criado com sucesso!', data.result);
    return { hostId: data.result.hostids[0], hostName: prefixedHostName };  // Retorna o ID do host e o nome do host criado com o prefixo
}
